import { BodyMediumRegular, YStack } from 'smoothie';

interface UpgradeCheckoutPaymentSheetProps {
    onSuccess: () => void;
}

// Stripe's PaymentSheet is a native-only prebuilt UI (@stripe/stripe-react-native).
// On web, UpgradeCheckout's PaymentElement flow already is the all-in-one widget,
// so there's no web variation to spike here.
export const UpgradeCheckoutPaymentSheet = (
    _props: UpgradeCheckoutPaymentSheetProps,
) => (
    <YStack width="100%">
        <BodyMediumRegular color="$gray1000">
            PaymentSheet is native-only. See the regular Upgrade Checkout
            (PaymentElement) for the web equivalent.
        </BodyMediumRegular>
    </YStack>
);

export default UpgradeCheckoutPaymentSheet;
